import { ChangeDetectorRef, Component, Input, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { FiltersOptionsType, IFiltersOptionsParam } from 'src/app/data/store/models/filters.model';
import {
  selectFiltersState,
  selectFiltersStateHaveOptions,
} from 'src/app/data/store/selectors/filters.selectors';
import { FiltersModalSteps, FiltersOptions } from '../../enums';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UtilsService } from '../../services/utils.service';
import { DepartmentsService } from '../../services/departments/departments.service';
import { AsyncPipe } from '@angular/common';
import { FiltersMenuComponent } from './components/filters-menu/filters-menu.component';
import { FiltersListComponent } from './components/filters-list/filters-list.component';

@UntilDestroy()
@Component({
  selector: 'app-filters-modal',
  templateUrl: './filters-modal.component.html',
  styleUrls: ['./filters-modal.component.scss'],
  imports: [FiltersMenuComponent, FiltersListComponent, AsyncPipe],
})
export class FiltersModalComponent implements OnInit {
  private _store = inject(Store);
  private _utils = inject(UtilsService);
  private _departmentsService = inject(DepartmentsService);
  private _cdRef = inject(ChangeDetectorRef);

  @Input() isOnlyFiltersList = false;

  public step: FiltersModalSteps = FiltersModalSteps.menu;

  readonly filtersModalSteps = FiltersModalSteps;

  public activeFilterList: FiltersOptionsType | null = null;

  public menuOptions: FiltersOptionsType[] = [];

  public initialFilters: IFiltersOptionsParam | null = null;

  public withFavoriteOption = false;

  public onlyFavorite?: boolean;

  public isCheckboxType = false;

  public excludeSingleFiltersOptions?: FiltersOptions[];

  public filtersState$ = this._store.select(selectFiltersState);

  public filtersStateHaveOptions$: Observable<boolean> = this._store.select(
    selectFiltersStateHaveOptions(),
  );

  ngOnInit(): void {
    this.filtersStateHaveOptions$ = this._store.select(
      selectFiltersStateHaveOptions(this.excludeSingleFiltersOptions),
    );

    this.filtersState$.pipe(untilDestroyed(this)).subscribe((filters) => {
      this.initialFilters = Object.assign({}, filters.filtersList) || null;
      this.menuOptions = this.prepareMenuOptions(filters?.filtersList ?? undefined);

      if (filters.favs !== null) {
        this.onlyFavorite = filters.favs;
      }
    });

    const dataFromUrl = this._utils.getFiltersFromUrl();

    const filters: any = this.initialFilters;
    const loadCondition =
      !Object.values(filters).filter((i: any) => !!i?.params && i.params[0] !== 'ALL').length &&
      !!Object.keys(dataFromUrl).length;

    if (loadCondition) {
      this._utils.updateStateFilterOnInit(false, this.initialFilters);
    }
  }

  public goToFiltersList(option: FiltersOptionsType) {
    this.activeFilterList = option;
    this.step = FiltersModalSteps.filterList;
  }

  public prepareMenuOptions(filtersList?: IFiltersOptionsParam) {
    return Object.entries(filtersList || {})
      .sort((op1, op2) => (op1[1].order && op2[1].order ? op1[1].order - op2[1].order : 0))
      .map(([option]) => option) as FiltersOptionsType[];
  }
}
